import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { productsApi } from "api/api/productsApi/productsApi";
import { GetProductsByMarathonIdParams, GetProductsByMarathonIdResponse } from "api/api/productsApi/types";

export const getProductsByMarathonId = createAsyncThunk<
  GetProductsByMarathonIdResponse[],
  GetProductsByMarathonIdParams
>("products/getProductsByMarathonId", async ({ marathonId }, { rejectWithValue }) => {
  try {
    const data = await productsApi.getProductsByMarathonId({ marathonId });
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while getting products", error?.response?.data);
      return rejectWithValue(error?.response?.data || "Unknown error");
    } else {
      console.error("Error while getting products", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
